const AppListItem = ({ imageSource, content }) => (
  <li className="text-2xl font-bold flex items-center gap-4">
    <img src={imageSource} alt="app feature" className="w-20 h-20" />
    {content}
  </li>
);

export default AppListItem;
